var React = require('react');

function Be (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"d":"M0 0h213.3v480H0z","key":0}),React.createElement("path",{"fill":"#ffd90c","d":"M213.3 0h213.4v480H213.3z","key":1}),React.createElement("path",{"fill":"#f31830","d":"M426.7 0H640v480H426.7z","key":2})]));
}

Be.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Be;

Be.default = Be;
